import React from 'react'
import { createRoot } from 'react-dom/client'
import { Main } from "./components/Main";
import './i18n';

// Initialize rendering
const rootElement = document.getElementById("root");
const root = createRoot(rootElement!);
root.render(<Main />);
